// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStoreVariants = (client) => ({
    /**
     * `GET /store/variants/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreVariantsIdRetrieveCompat
     * @source apps/backend/src/api/store/variants/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/store/variants/:id", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=variants.js.map